import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  exams: [],
  currentExam: null,
  examResults: [],
  loading: false,
  error: null,
};

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    fetchExamsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchExamsSuccess: (state, action) => {
      state.loading = false;
      state.exams = action.payload.exams || [];
    },
    fetchExamsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCurrentExam: (state, action) => {
      state.currentExam = action.payload;
    },
    submitExamStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    submitExamSuccess: (state, action) => {
      state.loading = false;
      state.examResults.push(action.payload);
    },
    submitExamFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchResultsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchResultsSuccess: (state, action) => {
      state.loading = false;
      state.examResults = action.payload;
    },
    fetchResultsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCurrentExam: (state) => {
      state.currentExam = null;
    },
  },
});

export const {
  fetchExamsStart,
  fetchExamsSuccess,
  fetchExamsFailure,
  setCurrentExam,
  submitExamStart,
  submitExamSuccess,
  submitExamFailure,
  fetchResultsStart,
  fetchResultsSuccess,
  fetchResultsFailure,
  clearCurrentExam,
} = examSlice.actions;

export default examSlice.reducer; 